export default {
    languages: {},
    navs: {},
    location: [],
    language: 'en',
    checked: null,
    user: null,
    newOrder: null,
    listState: [
        {
            id: 1,
            title: "Новые",

        },
        {
            id: 2,
            title: "Принятые",

        },
        {
            id: 3,
            title: "Отмененные",

        },
        {
            id: 4,
            title: "Выполненные",

        },
    ],
    /**Dynamic models of list for select */
    modals: {
        rubric: {
            modalCreate: "rubric",
            fields: [
                {
                    label: "Название",
                    key: "title",
                    type: "field",
                    textType: "numeric",
                },
                {
                    label: "Ссылка",
                    key: "slug",
                    type: "field",
                    textType: "numeric",
                },
            ],
            isAdd: false,
            isUpdate: true,
            searchDisable: true,
            removeLink: "rubrics/delete",
            cardLink: "rubric/card",
            itemLink: "rubrics/list",
            setLink: "rubrics/add",
            columns: [

                {
                    key: "title",
                    title: "Наименование",
                    checkbox: true,
                    control: false,
                    align: "left",
                    timer: false,
                },
                {
                    key: "slug",
                    title: "Ссылка",
                    checkbox: false,
                    control: false,
                    align: "left",
                    timer: false,
                },
            ],
        },
        banner: {
            modalCreate: "banner",
            fields: [
                {
                    label: "Название",
                    key: "title",
                    type: "field",
                    textType: "text",
                },

                {
                    label: "Ширина ПК (px)",
                    key: "width",
                    type: "field",
                    textType: "numeric",
                },
                {
                    label: "Высота ПК (px)",
                    key: "height",
                    type: "field",
                    textType: "numeric",
                },
                {
                    label: "Ширина Моб. (px)",
                    key: "m_width",
                    type: "field",
                    textType: "numeric",
                },
                {
                    label: "Высота Моб. (px)",
                    key: "m_height",
                    type: "field",
                    textType: "numeric",
                },
            ],
            isAdd: true,
            isUpdate: true,
            searchDisable: true,
            removeLink: "banners/delete",
            cardLink: "banner",
            itemLink: "banners/list",
            setLink: "banners/add",
            columns: [
                {
                    key: "title",
                    title: "Наименование",
                    checkbox: true,
                    control: false,
                    align: "left",
                    timer: false,
                },
                {
                    key: "",
                    title: "",
                    detail: true,
                    control: false,
                    align: "left",
                    timer: false,
                },
            ],
        },
        category_kit: {
            modalCreate: "category",
            fields: [
            ],
            params: {
                type: 'categories'
            },
            /** APIs */
            removeLink: "kit/delete",
            cardLink: "kit",
            itemLink: "kits/list",
            setLink: "kit/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        categories: {
            modalCreate: "category",
            fields: [

            ],
            params: {},
            /** APIs */
            removeLink: "",
            cardLink: "category",
            itemLink: "categories/list",
            setLink: "categories/add",
            /** COLUMNS MODEL */
            columns: [

                {
                    key: "full_title",
                    title: "Название",
                    checkbox: true,

                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        brand_kit: {
            modalCreate: "brand",
            fields: [
            ],
            params: {
                type: 'brands'
            },
            /** APIs */
            removeLink: "kit/delete",
            cardLink: "kit",
            itemLink: "kits/list",
            setLink: "kit/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        brands: {
            modalCreate: "brands",
            fields: [
            ],
            /** APIs */
            removeLink: "",
            cardLink: "brands",
            itemLink: "brands/list",
            setLink: "brands/add",
            /** COLUMNS MODEL */
            columns: [
                // {
                //     key: "image",
                //     title: "",
                //     checkbox: false,
                //     image: true,
                //     align: "left",
                //     timer: false,
                //     detail: false,
                // },
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        page_kit: {
            modalCreate: "page",
            fields: [
            ],
            params: {
                type: 'pages'
            },
            /** APIs */
            removeLink: "kit/delete",
            cardLink: "kit",
            itemLink: "kits/list",
            setLink: "kit/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        pages: {
            modalCreate: "page",
            fields: [
            ],
            params: {},
            /** APIs */
            removeLink: "pages/delete",
            cardLink: "page",
            itemLink: "pages/list",
            setLink: "pages/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        shop: {
            modalCreate: "shop",
            fields: [
            ],
            params: {},
            /** APIs */
            removeLink: "shops/delete",
            cardLink: "shop",
            itemLink: "shops/list",
            setLink: "shops/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        partner: {
            modalCreate: "partner",
            fields: [
            ],
            params: {},
            /** APIs */
            removeLink: "partners/delete",
            cardLink: "partner",
            itemLink: "partners/list",
            setLink: "partners/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        type: {
            modalCreate: "type",
            fields: [
            ],
            params: {},
            /** APIs */
            removeLink: "types/delete",
            cardLink: "type",
            itemLink: "types/list",
            setLink: "types/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                }
            ],
        },
        delivery: {
            modalCreate: "delivery",
            fields: [
            ],
            params: {},
            /** APIs */
            removeLink: "deliveries/delete",
            cardLink: "delivery",
            itemLink: "deliveries/list",
            setLink: "deliveries/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
                {
                    key: "price",
                    title: "Цена",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
            ],
        },
        payment: {
            modalCreate: "page",
            fields: [
            ],
            params: {},
            /** APIs */
            removeLink: "",
            cardLink: "payments",
            itemLink: "payments/list",
            setLink: "payments/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "id",
                    title: "Название",
                    checkbox: false,
                    full: false,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
                {
                    key: "percent_transaction",
                    title: "Процент транзакции",
                    checkbox: false,
                    full: false,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
                {
                    key: "unit",
                    title: "Ключ",
                    checkbox: false,
                    full: false,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
            ],
        },
        product: {
            modalCreate: "product",
            fields: [
            ],
            params: {
            },
            /** APIs */
            simple: false,
            removeLink: "",
            cardLink: "product",
            itemLink: "products/list",
            setLink: "",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "image",
                    title: "",
                    image: true,
                },
                {
                    key: "sku",
                    title: "Баркод",
                    checkbox: true,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
                {
                    key: "display_name",
                    title: "Название",
                    checkbox: false,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
                {
                    key: "business",
                    object: "name",
                    title: "Бизнес",
                    checkbox: false,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },

                {
                    key: "price_main",
                    title: "Главная цена",
                    checkbox: false,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },
                {
                    key: "price",
                    title: "Цена",
                    checkbox: false,
                    full: false,
                    control: false,
                    align: "left",
                    timer: false,
                    detail: false,
                },

                {
                    key: "quantity",
                    title: "Остаток",
                    checkbox: false,
                    full: false,
                    control: false,
                    align: "right",
                    timer: false,
                    detail: false,
                },
            ],
        },
        label: {
            modalCreate: "label",
            fields: [
            ],
            /** APIs */
            removeLink: "kit/delete",
            cardLink: "label",
            itemLink: "labels/list",
            setLink: "labels/add",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",

                }
            ],
        },
        status: {
            modalCreate: "status",
            fields: [
            ],
            /** APIs */
            removeLink: "",
            cardLink: "status",
            itemLink: "statuses/list",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",

                }
            ],
        },
        client: {
            modalCreate: "client",
            fields: [
            ],
            /** APIs */
            removeLink: "",
            cardLink: "clients",
            itemLink: "clients/list",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Пользователь",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                },
            ],
        },
        navs: {
            modalCreate: "navs",
            fields: [
            ],
            /** APIs */
            removeLink: "",
            cardLink: "navs",
            itemLink: "users/navs",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Раздел",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                },
            ],
        },
        color: {
            modalCreate: "color",
            fields: [
            ],
            /** APIs */
            removeLink: "",
            cardLink: "color",
            itemLink: "colors/list",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                }
            ],
        },
        name: {
            modalCreate: "name",
            fields: [
            ],
            /** APIs */
            removeLink: "",
            cardLink: "names",
            itemLink: "names/list",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "title",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                }
            ],
        },
        business: {
            modalCreate: "business",
            fields: [
            ],
            /** APIs */
            removeLink: "",
            cardLink: "business",
            itemLink: "businesses/list",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "name",
                    title: "Название бизнеса",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                }
            ],
        },
        group: {
            modalCreate: "group",
            fields: [
            ],
            /** APIs */
            removeLink: "",
            cardLink: "group",
            itemLink: "products/groups",
            /** COLUMNS MODEL */
            columns: [
                {
                    key: "display_name",
                    title: "Название",
                    checkbox: true,
                    full: true,
                    control: false,
                    align: "left",
                }
            ],
        },
    },
    modalName: null,
    valueSelected: null,
    lastUpdate: null,
    items: {
        banner: 'Banner',
        order: 'Order',
        group: 'Group',
        page: 'Page',
        labels: 'Labels',
        kit: 'Kit',
        promocode: 'Promocode',
        delivery: 'Delivery',
        feature: 'Feature',
        shop: 'Shop',
        type: 'Type',
        payment: 'Payment',
        brand: 'Brand',
        color: 'Color',
        value: 'Value',
        name: 'Name',
        partner: 'Partner',
        product: 'Product',
        category: 'Category',
        user: 'User',
        subfeature: 'Subfeature',
        scoring: 'Scoring',
        client: 'Client',
    }
}